import React from 'react';
import Campaigns from './Campaigns';

export default () => (
  <Campaigns />
);
